import React from 'react';
import '../../../assets/css/common/video/comment.css';
import SubHeaderComponent from '../../../components/header/subheader';
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import { Toast } from 'antd-mobile';


export default class commentIndex extends React.Component {
	constructor(props){
		super(props);
		let merchand = props.location.state !== undefined?props.location.state.merchand:JSON.parse(localStorage['merchand']);
		
		this.state = {
			data: {
			  "logTeacherParam": {
				"TeachId": merchand.TeacherId,
				"merchandiseId": merchand.merchandiseId,
				"tscore": 5,
				"ContentId": [],
				"tPropose": ""
			  },
			  "merchandisescoreParam": {
				"merchandiseId": merchand.merchandiseId,
				"orgId": merchand.Org_ID,
				"score": 5,
				"ContentId": [],
				"Propose": ""
			  }
			},
			teacherPJArr: [],
			KCPJARR: [],
			score: ['非常不满意','不满意','一般','满意','非常满意']
		}
	}
	componentDidMount(props) {
		request(config.baseUrl+'api/Study/S044?type=1', "post").then(res=>{
			if(res.code == 0 && res.data.length>0){
				res.data.forEach(item =>{
					item.checked = false
				})
		    	this.setState({
		    		teacherPJArr: res.data
		    	})
		    }
		});
		request(config.baseUrl+'api/Study/S044?type=2', "post").then(res=>{
			if(res.code == 0 && res.data.length>0){
				res.data.forEach(item =>{
					item.checked = false
				})
		    	this.setState({
		    		KCPJARR: res.data
		    	})
		    }
		});
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	imageClick(val,index){
		let data = this.state.data;
		if(val == 'logTeacherParam'){
			this.state.data.logTeacherParam.tscore = index;
		}else if(val == 'scoreParam'){
			this.state.data.merchandisescoreParam.score = index;
		} 
		this.setState({
			data: data
		})
	}
	teacherClick(index){
		let teacherPJArr = this.state.teacherPJArr;
		teacherPJArr[index].checked = !teacherPJArr[index].checked;
		this.setState({
			teacherPJArr: teacherPJArr
		})
	}
	KCPJClick(index){
		let KCPJARR = this.state.KCPJARR;
		KCPJARR[index].checked = !KCPJARR[index].checked;
		this.setState({
			KCPJARR: KCPJARR
		})
	}
	submitJson(){
		this.state.KCPJARR.forEach(item => {
			if(item.checked){
				this.state.data.merchandisescoreParam.ContentId.push(item.eId);
			}
		})
		this.state.teacherPJArr.forEach(item => {
			if(item.checked){
				this.state.data.logTeacherParam.ContentId.push(item.eId);
			}
		})
		request(config.baseUrl+'api/Study/S036', "post", this.state.data ).then(res=>{
			if(res.code == 0){
				Toast.info(res.message,2);
		    }
		});
	}
	render() {
		return(
			<div className={'comment'}>
				<SubHeaderComponent title="评价"></SubHeaderComponent>
				<div>
					<div className='row'>
						<div className='child child1'>
							<div>
								<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
							</div>
							<div>
								<p>繁殖三角体系之健康三力</p>
								<p>
									<span>余奎</span>
								</p>
							</div>
						</div>
						<div className='child child2'>
							<p>老师讲课评分</p>
							<p>
							{
								this.state.score.map((item,index)=>{
									return(
										<img onClick={this.imageClick.bind(this, 'logTeacherParam', index)} src={index < this.state.data.logTeacherParam.tscore?require('../../../assets/images/video/stars2.png'):require('../../../assets/images/video/stars1.png')} key={index} />
									)
								})
							}
							</p>
							<p>{this.state.score[this.state.data.logTeacherParam.tscore-1]}</p>
						</div>
						<div className='child child3'>
						{
							this.state.teacherPJArr.map((item,index)=>{
								return(
									<p className={item.checked?'on':''} key={index} onClick={this.teacherClick.bind(this, index)}>{item.content}</p>
								)
							})
						}
						</div>
						<div className='child4'>
							<textarea placeholder='提出您对老师讲课的建议，我们会努力改进' onChange={(val)=>{
								this.state.data.logTeacherParam.tPropose = val.target.value;
							}}></textarea>
						</div>
					</div>
					<div className='row'>
						<div className='child child2' style={{marginTop: '0px'}}>
							<p>课程内容评分</p>
							<p>
							{
								this.state.score.map((item,index)=>{
									return(
										<img onClick={this.imageClick.bind(this, 'scoreParam', index)} src={index < this.state.data.merchandisescoreParam.score?require('../../../assets/images/video/stars2.png'):require('../../../assets/images/video/stars1.png')} key={index} />
									)
								})
							}
							</p>
							<p>{this.state.score[this.state.data.merchandisescoreParam.score-1]}</p>
						</div>
						<div className='child child3'>
						{
							this.state.KCPJARR.map((item,index)=>{
								return(
									<p className={item.checked?'on':''} key={index} onClick={this.KCPJClick.bind(this, index)}>{item.content}</p>
								)
							})
						}
						</div>
						<div className='child4'>
							<textarea placeholder='提出您对老师讲课的建议，我们会努力改进' onChange={(val)=>{
								this.state.data.merchandisescoreParam.Propose = val.target.value;
							}}></textarea>
						</div>
					</div>
					<div className='footbtn' onClick={this.submitJson.bind(this)}>
						提交
					</div>
				</div>
		    </div>
		);
	}
}